// extracted by mini-css-extract-plugin
module.exports = {"grid":"i_A9","heading":"i_BA","social-container":"i_BB","social":"i_BC","clipboard":"i_BD","copy":"i_BE","copied":"i_BF","link":"i_BG"};